module.exports = __webpack_public_path__ + "assets/fb36b0ba150beee0f7893e37dc4bbe43.svg";